import { PartnerCenterEnrollmentStatus } from "@gamedev-web/one-gaming-crm";

import { OrdersInfoData } from "../server/edsApi/models/forms";

export type StudioData = {
  sellerID: string;
  orders?: OrdersInfoData;
  partnerCenterEnrollmentStatus: PartnerCenterEnrollmentStatus;
  dunsNumber?: string;
  isEmbargoedCountry?: boolean;
};

export const hasAttemptedPartnerCenterEnrollment = (
  status: PartnerCenterEnrollmentStatus | null | undefined
) =>
  status !== null &&
  status !== undefined &&
  status !== PartnerCenterEnrollmentStatus.Unset &&
  status !== PartnerCenterEnrollmentStatus.Enabled;
